<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <div class="d-flex justify-content-between">
                    <h5><i class="fa fa-fw fa-cubes mr-2" />Status</h5>
                    <div class="text-right">
                        <b-btn v-if="isRekapAllowed" size="sm" class="mr-2" variant="primary" @click="getRekap(false)">
                            Per Tipe (Lokasi Terbatas)
                        </b-btn>
                        <b-btn v-if="isRekapAllowed" size="sm" class="mr-2" variant="primary" @click="getRekap(true)">
                            Per Tipe (Semua Lokasi)
                        </b-btn>
                        <b-btn size="sm" class="mr-2" variant="primary" @click="$bvModal.show('modal-status-count-tipe')">
                            Rekap
                        </b-btn>
                        <b-btn size="sm" variant="primary" :disabled="isGettingStatusCount" @click="getStatusCount">
                            <i class="fa fa-refresh" />
                        </b-btn>
                    </div>
                </div>
                <hr class="my-2" />
                <div class="brand-card-body" style="padding: 0">
                    <div v-for="item in statusCount" v-bind:key="item.name">
                        <div v-if="item.name == 'REPAIR'" class="text-value">{{ item.id }} ({{ wspbCount }})</div>
                        <div v-else class="text-value">{{ item.id }}</div>
                        <div v-if="item.name == 'REPAIR'" class="text-uppercase text-muted small">{{ item.name }} (w/ SPB)</div>
                        <div v-else-if="item.name == 'TOTAL'" class="text-uppercase small font-weight-bold">TOTAL</div>
                        <div v-else class="text-uppercase text-muted small">{{ item.name }}</div>
                    </div>
                </div>
            </b-card>
            <b-card>
                <div class="d-flex align-items-center justify-content-between">
                    <h4 class="mb-0"><i :class="'fa fa-fw mr-2 ' + categorySectionIcon" />{{ categoryName }}</h4>
                    <div v-if="isAddAllowed" class="text-right">
                        <b-button variant="dark" class="mr-2" @click="$bvModal.show('modal-tipe')">Daftar Tipe</b-button>
                        <b-button variant="dark" @click="$bvModal.show('modal-create')">
                            <i class="fa fa-plus mr-2" />Input Baru
                        </b-button>
                    </div>
                </div>
                <hr />
                <div class="search-wrapper d-flex align-items-center justify-content-between mb-2">
                    <b-form-group
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-0"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="mr-2" style="max-width: 200px"
                                v-model="filter.sn"
                                type="search"
                                id="filterInput"
                                placeholder="SN"
                                @keydown.enter="getItems"
                            />
                        </div>
                    </b-form-group>
                    <b-form-select v-model="filter.status" :options="optStatus" class="mr-2" style="max-width: 100px">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                            <b-form-select-option value=-1>Semua</b-form-select-option>
                        </template>
                    </b-form-select>
                    <multiselect v-model="filter.type"
                        class="mr-2"
                        :options="optTipe"
                        :allow-empty="true"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Tipe"
                    />
                    <multiselect v-model="filter.manufacturer"
                        class="mr-2"
                        :options="optManufacturer"
                        :allow-empty="true"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Manufaktur"
                    />
                    <multiselect v-model="filter.wilayah"
                        class="mr-2"
                        :options="optWilayah"
                        :allow-empty="true"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Wilayah"
                    />
                    <multiselect v-model="filter.lokasi"
                        class="mr-2"
                        :options="optLokasi"
                        :allow-empty="true"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Lokasi"
                        :disabled="filter.wilayah == null"
                    />
                </div>
                <div class="search-wrapper d-flex align-items-center mb-3">
                    <b-form-select v-model="filter.lokasiStatus" class="mr-2" style="max-width: 200px">
                        <template v-slot:first>
                            <b-form-select-option :value="-1">Semua Status Lokasi</b-form-select-option>
                            <b-form-select-option :value="2">DHP</b-form-select-option>
                            <b-form-select-option :value="3">Lainnya</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-input v-if="useSearch1" class="mr-2" style="max-width: 150px"
                        v-model="filter.search1"
                        type="search"
                        :placeholder="search1Title"
                        @keydown.enter="getItems"
                    />
                    <b-form-input v-if="useSearch2" class="mr-2" style="max-width: 150px"
                        v-model="filter.search2"
                        type="search"
                        :placeholder="search2Title"
                        @keydown.enter="getItems"
                    />
                    <b-form-select v-if="useActive" v-model="filter.active" class="mr-2" style="max-width: 100px">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Status Aktif</b-form-select-option>
                            <b-form-select-option value=-1>Semua</b-form-select-option>
                            <b-form-select-option value=0>OFF</b-form-select-option>
                            <b-form-select-option value=1>ON</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-button variant="primary" class="mr-2" @click="getItems">
                        <i class="fa fa-search mr-2" /> Search
                    </b-button>
                    <b-button variant="danger" @click="resetSearch">
                        <i class="fa fa-times mr-2" /> Reset Search
                    </b-button>
                    <b-button v-if="isDownloadExcelAllowed()" class="ml-2" variant="success" @click="$bvModal.show('modal-excel')">
                        <i class="fa fa-download mr-2" /> Download Excel
                    </b-button>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    responsive class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada {{ categoryName }}.
                    </template>
                    <template v-slot:cell(log)="row">
                        <b-button size="sm" variant="primary" @click="prepareLogModal(row.item, 'modal-log')">
                            <i class="fa fa-book" />
                        </b-button>
                    </template>
                    <template v-slot:cell(sn)="row">
                        {{ row.item.sn }}
                        <!-- <b-btn variant="link" size="sm" @click="copyToClipboard(row.item.sn); event.preventDefault()">Copy</b-btn> -->
                        <a class="small" href="#" @click="copyToClipboard(row.item.sn, $event)">[Copy]</a>
                        <div v-if="row.item.description != null" class="small text-muted">{{ row.item.description }}</div>
                    </template>
                    <template v-slot:cell(type)="row">
                        {{ row.item.type }}
                        <div class="small text-muted">{{ row.item.manufacturer }}</div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseInventoryStatusBadge(row.item.status)">{{ row.item.status }}</b-badge>
                        <span v-if="row.item.repairExternal == true" class="small ml-1">EXT</span>
                        <div v-if="useActive">
                            <div v-if="row.item.active == true" class="small font-weight-bold">ON</div>
                            <div v-else class="small text-danger font-weight-bold">OFF</div>
                        </div>
                    </template>
                    <template v-slot:cell(location)="row">
                        {{ row.item.location }}
                        <b-badge v-if="row.item.lokasiStatus == 2" variant="dark">DHP</b-badge>
                        <b-badge v-else-if="row.item.lokasiStatus == 3" variant="warning">LAINNYA</b-badge>
                        <div class="small text-muted">{{ row.item.wilayah }}</div>
                    </template>
                    <template v-slot:cell(plan)="row">
                        <div v-if="row.item.planNo != null">
                            {{ row.item.planNo }}
                            <div class="small text-muted">{{ row.item.planLocation }}</div>
                        </div>
                    </template>
                    <template v-slot:cell(action)="row" style="padding-top: 0">
                        <b-button v-if="row.item.hasPendingSpb" size="sm" variant="danger" class="mr-2 mb-2" v-b-tooltip.hover.top title="SPB" @click="openSpbDetail(row.item)">
                            SPB
                        </b-button>
                        <b-button v-if="isEditAllowed" size="sm" variant="primary" class="mr-2 mb-2" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                            <i class="fa fa-fw fa-edit" />
                        </b-button>
                        <b-button size="sm" variant="dark" class="mr-2 mb-2" v-b-tooltip.hover.top title="Catatan" @click="openModal('modal-catatan', row.item)">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                        <b-button v-if="isSetReadyAllowed(row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover.top title="Set Ready Line" @click="openModal('modal-set-ready', row.item)">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                        <b-button v-if="isSetPindahAllowed(row.item)" size="sm" variant="primary" class="mr-2 mb-2" v-b-tooltip.hover.top title="Set Pindah" @click="openModal('modal-set-pindah', row.item)">
                            <i class="fa fa-fw fa-truck" />
                        </b-button>
                        <b-button v-if="isReturAllowed(row.item)" size="sm" variant="warning" class="mr-2 mb-2" v-b-tooltip.hover.top title="Retur" @click="openModal('modal-retur', row.item)">
                            <i class="fa fa-fw fa-truck" />
                        </b-button>
                        <b-button v-if="isSetActiveAllowed(row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover.top title="Set Installed" @click="openModal('modal-set-active', row.item)">
                            <i class="fa fa-fw fa-flag" />
                        </b-button>
                        <b-button v-if="isSetRepairAllowed(row.item)" size="sm" variant="danger" class="mr-2 mb-2" v-b-tooltip.hover.top title="Repair External" @click="openModal('modal-set-repair', row.item)">
                            <i class="fa fa-fw fa-wrench" />
                        </b-button>
                        <!-- <b-button v-if="isScrapAllowed(row.item)" size="sm" variant="warning" class="mr-2 mb-2" v-b-tooltip.hover.top title="Scrap" @click="openModal('modal-set-scrap', row.item)">
                            <i class="fa fa-fw fa-trash" />
                        </b-button> -->
                        <b-button v-if="isFinishRepairAllowed(row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover.top title="Repair Selesai" @click="openModal('modal-set-repair-selesai', row.item)">
                            <i class="fa fa-fw fa-truck" />
                        </b-button>
                        <b-button v-if="isSwitchActiveAllowed()" size="sm" variant="primary" class="mr-2 mb-2" v-b-tooltip.hover.top title="Switch On Off" @click="openModal('modal-switch-on-off', row.item)">
                            <i class="fa fa-fw fa-power-off" />
                        </b-button>
                        <b-button v-if="isRecoverFromScrapAllowed(row.item)" size="sm" variant="success" class="mr-2 mb-2" v-b-tooltip.hover.top title="Pengaktifan Kembali" @click="openModal('modal-recover-from-scrap', row.item)">
                            <i class="fa fa-fw fa-refresh" />
                        </b-button>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :totalRows="totalRows"
                        :per-page="perPage"
                        @change="onPageChange"
                    />
                </div>
            </b-card>
        </div>
        <b-modal id="modal-tipe" size="lg" no-close-on-esc hide-footer no-close-on-backdrop title="Daftar Tipe">
            <ModalInventoryType :categoryId="categoryId" :categoryName="categoryName" @change="getTipe" />
        </b-modal>
        <b-modal id="modal-status-count-tipe" size="xl" hide-footer no-close-on-backdrop title="Rekap">
            <ModalStatusCount :categoryId="categoryId" />
        </b-modal>
        <b-modal id="modal-create" no-close-on-esc hide-footer no-close-on-backdrop title="Input Baru" @shown="$refs.inputSn.focus()">
            <b-form-group label="Serial Number (SN)">
                <b-form-input ref="inputSn" v-model="input.sn" maxlength="100" />
            </b-form-group>
            <b-form-group label="Tipe">
                <multiselect v-model="input.type"
                    :options="optTipe"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih tipe"
                />
            </b-form-group>
            <b-form-group label="Manufacturer">
                <multiselect v-model="input.manufacturer"
                    :options="optManufacturer"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih manufacturer"
                />
            </b-form-group>
            <b-form-group label="Warehouse">
                <multiselect v-model="input.warehouse"
                    :options="optWarehouse"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih warehouse"
                />
            </b-form-group>
            <b-form-group v-if="useSearch1" :label="search1Title">
                <b-form-input v-model="input.search1" maxlength="50" />
            </b-form-group>
            <b-form-group v-if="useSearch2" :label="search2Title">
                <b-form-input v-model="input.search2" maxlength="50" />
            </b-form-group>
            <b-form-group label="Deskripsi (Opsional)">
                <b-form-input v-model="input.description" maxlength="255" />
            </b-form-group>
            <b-alert variant="info" show>
                Semua barang baru akan ditambahkan dengan status <strong>READY LINE</strong>.
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeInput">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-edit" no-close-on-esc hide-footer no-close-on-backdrop title="Edit" @shown="$refs.editSn.focus()">
            <b-form-group label="Serial Number (SN)">
                <b-form-input ref="editSn" v-model="edit.sn" maxlength="100" />
            </b-form-group>
            <b-form-group label="Tipe">
                <multiselect v-model="edit.type"
                    :options="optTipe"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih tipe"
                />
            </b-form-group>
            <b-form-group label="Manufacturer">
                <multiselect v-model="edit.manufacturer"
                    :options="optManufacturer"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih manufacturer"
                />
            </b-form-group>
            <b-form-group v-if="useSearch1" :label="search1Title">
                <b-form-input v-model="edit.search1" maxlength="50" />
            </b-form-group>
            <b-form-group v-if="useSearch2" :label="search2Title">
                <b-form-input v-model="edit.search2" maxlength="50" />
            </b-form-group>
            <b-form-group label="Deskripsi (Opsional)">
                <b-form-input v-model="edit.description" maxlength="255" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="executeEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-excel" title="Cetak Excel" centered no-close-on-esc no-close-on-backdrop hide-footer @hidden="printStatus = 0">
            <div v-if="printStatus == 0">
                <div>
                    <b-button variant="success" @click="executeDownloadExcelInventory">Download Excel {{ categoryName }} List</b-button>
                </div>
                <hr />
                <div>
                    <b-input-group>
                        <b-form-input type="date" v-model="tanggalInputExcel" :max="maxDate" />
                        <b-input-group-append>
                            <b-button variant="success" @click="executeDownloadExcelLog">Download Excel Log List</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div v-else-if="printStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark"></b-spinner>
                <div class="mt-2">Mohon menunggu...</div>
            </div>
            <div v-else-if="printStatus == 2">
                <div class="mb-2">Excel siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="excelPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
        <b-modal id="modal-spb" no-close-on-esc hide-footer no-close-on-backdrop title="SPB Pending">
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                SPB pending untuk <strong>{{ activeItem.sn }}</strong>:
                <ul>
                    <li v-for="spb in spbs" v-bind:key="spb">{{ spb }}</li>
                </ul>
            </div>
        </b-modal>
        <LogModal :main="activeItem" :title="logTitle" @should-refresh="shouldRefresh" />
        <ModalInventoryActions
            :unit="activeItem"
            :category="categoryName"
            :optWilayah="optWilayah"
            :optWarehouse="optWarehouse"
            @should-refresh="shouldRefresh"
        />
        <ModalRekapInventory
            :isLoading="isRetrievingRekap"
            :items="rekap"
            :categoryId="categoryId"
            :useAllLocation="rekapUseAllLocation"
        />
    </div>
</template>

<script>
import ModalInventoryType from './ModalInventoryType'
import ModalStatusCount from './ModalStatusPerTypeCount'
import ModalInventoryActions from './ModalInventoryActions'
import ModalRekapInventory from './ModalRekapInventory'
import LogModal from '@/views/logs/LogInventory'

export default {
    name: 'base-inventory',
    components: { ModalInventoryType, ModalStatusCount, LogModal, ModalInventoryActions, ModalRekapInventory },
    props: {
        categoryId: { type: String, required: true },
        categoryName: { type: String, required: true },
        categorySectionIcon: { type: String, required: true },
        useSearch1: { type: Boolean, default: false },
        useActive: { type: Boolean, default: false },
        search1Title: { type: String, required: false },
        useSearch2: { type: Boolean, default: false },
        search2Title: { type: String, required: false },
        showRekapPump: { type: Boolean, default: false },
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,
            isRetrievingRekap: false,

            isGettingStatusCount: false,
            statusCount: [],
            wspbCount: 0,
            logTitle: "",
            printStatus: 0,

            tanggalInputExcel: "",
            maxDate: "",

            filter: {
                sn: "",
                type: null,
                status: -1,
                manufacturer: null,
                wilayah: null,
                lokasi: null,
                search1: "",
                search2: "",
                active: -1,
                lokasiStatus: -1
            },

            input: {
                sn: "",
                type: null,
                manufacturer: null,
                warehouse: null,
                description: "",
                search1: "",
                search2: ""
            },

            edit: {
                sn: "",
                type: null,
                manufacturer: null,
                description: "",
                search1: "",
                search2: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "log", label: "Log" },
                { key: "sn", label: "SN" },
                { key: "type", label: "Tipe & Manufaktur" },
                { key: "status", label: "Status" },
                { key: "location", label: "Lokasi" },
                { key: "plan", label: "Plan" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            rekap: [],
            rekapUseAllLocation: false,
            spbs: [],

            optTipe: [],
            optManufacturer: [],
            optWarehouse: [],
            optWilayah: [],
            optLokasi: [],
            optStatus: [
                { value: 0, text: "Ready Line" },
                { value: 1, text: "Shipment" },
                { value: 2, text: "Installed" },
                { value: 3, text: "Retur" },
                { value: 4, text: "Repair" },
                { value: 5, text: "Inoperative" },
                { value: 6, text: "Lainnya" },
                { value: 7, text: "Junk" }
            ]

        }
    },
    computed: {

        isAddAllowed() {
            return [0, 8].includes(this.$helper.getRoleId())
        },

        isEditAllowed() {
            return [0, 8].includes(this.$helper.getRoleId())
        },

        isRekapAllowed() {
            return [0, 7, 8, 10].includes(this.$helper.getRoleId())
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            let getWilayah = this.$axios.get("wilayah/selection?all=true").then(res => {
                this.optWilayah = res.data
            })

            let getManufacturer = this.$axios.get("manufacturer/").then(res => {
                this.optManufacturer = res.data
            })

            let getWarehouse = this.$axios.get("lokasi/warehouse").then(res => {
                this.optWarehouse = res.data
            })

            let getTipe = this.getTipe()
            let getItems = this.getItems()
            let getStatusCount = this.getStatusCount()

            Promise.all([getWilayah, getManufacturer, getTipe, getItems, getStatusCount, getWarehouse]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        getStatusCount() {

            this.isGettingStatusCount = true
            return this.$axios.get("inventory/status-count/?categoryId=" + this.categoryId).then(res => {
                this.statusCount = res.data.detail
                this.wspbCount = res.data.wspbCount
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isGettingStatusCount = false)

        },

        getTipe() {

            return this.$axios.get("inventory-type/?categoryId=" + this.categoryId).then(res => {
                this.optTipe = res.data
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&categoryId=" + this.categoryId

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.lokasi)) {
                param += "&filterLokasi=" + this.filter.lokasi.id
            }
            else if(!this.$helper.isBlank(this.filter.wilayah)) {
                param += "&filterWilayah=" + this.filter.wilayah.id
            }

            if(!this.$helper.isBlank(this.filter.type)) {
                param += "&filterType=" + this.filter.type.id
            }

            if(!this.$helper.isBlank(this.filter.manufacturer)) {
                param += "&filterManufacturer=" + this.filter.manufacturer.id
            }

            if(this.useSearch1 && !this.$helper.isBlank(this.filter.search1)) {
                param += "&filterSearch1=" + this.filter.search1
            }

            if(this.useSearch2 && !this.$helper.isBlank(this.filter.search2)) {
                param += "&filterSearch2=" + this.filter.search2
            }

            if(this.useActive && this.filter.active != -1) {
                param += "&filterActive=" + (this.filter.active == 0 ? "false" : "true")
            }

            if(this.filter.lokasiStatus != -1) {
                param += "&filterLokasiStatus=" + this.filter.lokasiStatus
            }

            // Execute
            return this.$axios.get("inventory/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeInput() {

            // Check
            let list = [
                [this.input.sn, "SN"],
                [this.input.type, "Tipe"],
                [this.input.manufacturer, "Manufacturer"],
                [this.input.warehouse, "Warehouse"]
            ]

            if(this.useSearch1 == true) {
                list.push([this.input.search1, this.search1Title])
            }

            if(this.useSearch2 == true) {
                list.push([this.input.search2, this.search2Title])
            }

            let check = this.checkIfValidSubmission(list)
            if(check != null) {
                return this.$helper.toastError(this, `${check} tidak boleh kosong!`)
            }

            let payload = new FormData()
            payload.append("sn", this.input.sn)
            payload.append("typeId", this.input.type.id)
            payload.append("manufacturerId", this.input.manufacturer.id)
            payload.append("locationId", this.input.warehouse.id)
            payload.append("categoryId", this.categoryId)

            if(this.useSearch1 == true) {
                payload.append("search1", this.input.search1)
            }

            if(this.useSearch2 == true) {
                payload.append("search2", this.input.search2)
            }

            if(!this.$helper.isBlank(this.input.description)) {
                payload.append("description", this.input.description)
            }

            this.isSubmitting = true
            this.$axios.post("inventory/", payload).then(res => {

                this.$helper.toastSuccess(this, `${this.categoryName} baru berhasil ditambahkan!`)
                this.getItems()
                this.$bvModal.hide("modal-create")

                this.input.sn = ""
                this.input.description = ""
                this.input.search1 = ""
                this.input.search2 = ""

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        executeEdit() {

            // Check
            let list = [
                [this.edit.sn, "SN"],
                [this.edit.type, "Tipe"],
                [this.edit.manufacturer, "Manufacturer"]
            ]

            if(this.useSearch1 == true) {
                list.push([this.edit.search1, this.search1Title])
            }

            if(this.useSearch2 == true) {
                list.push([this.edit.search2, this.search2Title])
            }

            let check = this.checkIfValidSubmission(list)
            if(check != null) {
                return this.$helper.toastError(this, `${check} tidak boleh kosong!`)
            }

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("sn", this.edit.sn)
            payload.append("typeId", this.edit.type.id)
            payload.append("manufacturerId", this.edit.manufacturer.id)
            payload.append("categoryId", this.categoryId)

            if(this.useSearch1 == true) {
                payload.append("search1", this.edit.search1)
            }

            if(this.useSearch2 == true) {
                payload.append("search2", this.edit.search2)
            }

            if(!this.$helper.isBlank(this.edit.description)) {
                payload.append("description", this.edit.description)
            }

            this.isSubmitting = true
            this.$axios.post("inventory/", payload).then(res => {

                this.$helper.toastSuccess(this, `${this.categoryName} berhasil diubah!`)
                this.getItems(this.currentPage)
                this.$bvModal.hide("modal-edit")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {

            this.activeItem = item
            this.edit.sn = item.sn
            this.edit.description = item.description
            this.edit.search1 = item.search1
            this.edit.search2 = item.search2
            this.edit.type = this.optTipe.find(it => it.name == item.type)
            this.edit.manufacturer = this.optManufacturer.find(it => it.name == item.manufacturer)
            this.$bvModal.show("modal-edit")

        },

        prepareLogModal(item, modalId) {

            this.activeItem = item
            this.logTitle = item.sn
            this.$bvModal.show("modal-log")

        },

        executeDownloadExcelInventory() {

            let param = "?categoryId=" + this.categoryId

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.lokasi)) {
                param += "&filterLokasi=" + this.filter.lokasi.id
            }
            else if(!this.$helper.isBlank(this.filter.wilayah)) {
                param += "&filterWilayah=" + this.filter.wilayah.id
            }

            if(!this.$helper.isBlank(this.filter.type)) {
                param += "&filterType=" + this.filter.type.id
            }

            if(!this.$helper.isBlank(this.filter.manufacturer)) {
                param += "&filterManufacturer=" + this.filter.manufacturer.id
            }

            if(this.useSearch1 && !this.$helper.isBlank(this.filter.search1)) {
                param += "&filterSearch1=" + this.filter.search1
            }

            if(this.useSearch2 && !this.$helper.isBlank(this.filter.search2)) {
                param += "&filterSearch2=" + this.filter.search2
            }

            if(this.useActive && this.filter.active != -1) {
                param += "&filterActive=" + (this.filter.active == 0 ? "false" : "true")
            }

            if(this.filter.lokasiStatus != -1) {
                param += "&filterLokasiStatus=" + this.filter.lokasiStatus
            }

            // Execute
            this.printStatus = 1
            this.$axios.get("inventory/excel" + param).then(res => {
                this.excelPath = this.$BASE_FILE_PATH + res.data
                this.printStatus = 2
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.printStatus = 0
            })

        },

        executeDownloadExcelLog() {

            // Execute
            this.printStatus = 1
            this.$axios.get("log-inventory/excel-all-inventory?tanggal=" + this.tanggalInputExcel + "&categoryId=" + this.categoryId).then(res => {
                this.excelPath = this.$BASE_FILE_PATH + res.data
                this.printStatus = 2
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.printStatus = 0
            })

        },

        getRekap(useAllLocation) {

            this.rekapUseAllLocation = useAllLocation
            this.$bvModal.show("modal-rekap")

            this.isRetrievingRekap = true
            this.$axios.get("inventory/rekap?categoryId=" + this.categoryId + "&useAllLocation=" + useAllLocation).then(res => {
                this.rekap = res.data
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isRetrievingRekap = false)

        },

        openSpbDetail(item) {
            this.$bvModal.show("modal-spb")

            this.isSubmitting = true
            this.activeItem = item

            this.$axios.get("inventory/pending-spb/" + this.activeItem.id).then(res => [
                this.spbs = res.data
            ])
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        shouldRefresh() {
            this.getItems(this.currentPage)
        },

        checkIfValidSubmission(data) {

            for(var i = 0; i < data.length; i++) {

                let check = data[i]
                if(this.$helper.isBlank(check[0])) {
                    return check[1]
                }

            }

            return null

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        resetSearch() {

            this.filter.sn = ""
            this.filter.type = null
            this.filter.status = -1
            this.filter.manufacturer = null
            this.filter.wilayah = null
            this.filter.lokasi = null
            this.filter.search1 = ""
            this.filter.search2 = ""
            this.getItems()

        },

        parseInventoryStatusBadge(status) {

            switch(status) {
                case "READY LINE": return "dark"
                case "SHIPMENT": return "primary"
                case "INSTALLED": return "success"
                case "RETUR": return "warning"
                case "REPAIR": return "danger"
                case "INOPERATIVE": return "light"
                case "JUNK": return "light"
                case "LAINNYA": return "light"
                default: return "light"
            }

        },

        copyToClipboard(sn, e) {

            e.preventDefault()

            navigator.clipboard.writeText(sn).then(res =>
                this.$helper.toastSuccess(this, "SN tercopy ke clipboard anda!")
            )
            .catch(error => this.$helper.toastError(this, "Gagal mengcopy, browser anda tidak mensupport copy tulisan!"))

        },

        /// ACTIONABLES
        openModal(id, item) {
            this.activeItem = item
            this.$bvModal.show(id)
        },

        isSetReadyAllowed(item) {
            return item.status == "RETUR"
                && [0, 1, 8].includes(this.$helper.getRoleId())
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isSetRepairAllowed(item) {
            return ["RETUR", "READY LINE"].includes(item.status)
                && [0, 1, 8].includes(this.$helper.getRoleId())
                && item.planNo == null
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isScrapAllowed(item) {
            return ["RETUR", "READY LINE"].includes(item.status)
                && [0, 1, 8].includes(this.$helper.getRoleId())
                && item.planNo == null
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isSetPindahAllowed(item) {
            return ["RETUR", "READY LINE", "INOPERATIVE", "JUNK", "LAINNYA"].includes(item.status)
                && [0, 1, 8].includes(this.$helper.getRoleId())
                && item.planNo == null
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isSetActiveAllowed(item) {
            return item.status == "SHIPMENT"
                && [0, 2].includes(this.$helper.getRoleId())
                && item.planNo == null
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isFinishRepairAllowed(item) {
            return item.status == "REPAIR"
                && item.repairExternal == true
                && [0, 1, 8].includes(this.$helper.getRoleId())
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isReturAllowed(item) {
            return item.status == "INSTALLED"
                && [0, 1, 8].includes(this.$helper.getRoleId())
                && (this.$helper.getRoleId() == 0 || item.wilayahId == this.$helper.getWilayahId())
        },

        isSwitchActiveAllowed() {
            return this.useActive == true
                && [0, 2].includes(this.$helper.getRoleId())
        },

        isRecoverFromScrapAllowed(item) {
            return (item.status == "INOPERATIVE" || item.status == "JUNK")
                && [0].includes(this.$helper.getRoleId())
        },

        isDownloadExcelAllowed() {
            return this.$helper.getRoleId() == 0
        }

    },
    watch: {

        "filter.wilayah": function(newVal) {

            this.filter.lokasi = null

            if(newVal == null) {
                return
            }

            let append = ""
            if([0, 7, 8, 10].includes(this.$helper.getRoleId())) {
                append = "?all=true"
            }

            this.$axios.get("lokasi/selection/" + newVal.id + append).then(res => {
                this.optLokasi = res.data
            })

        }

    },
    created() {

        this.init()

        if(this.useSearch1 == true) {
            this.fields.splice(2, 0, { key: "search1", label: this.search1Title })
        }

        if(this.useSearch2 == true) {
            this.fields.splice(3, 0, { key: "search2", label: this.search2Title })
        }

        // Pasang tanggal pengerjaan ke hari ini
        let today = new Date()
        today.setHours(today.getHours() + 7)
        let maxDate = today.toISOString().substring(0, 10)

        this.tanggalInputExcel = maxDate
        this.maxDate = maxDate

    }
}
</script>
